import { render, staticRenderFns } from "./EventRemoveTeamDialog.vue?vue&type=template&id=12f00bd8&scoped=true"
import script from "./EventRemoveTeamDialog.vue?vue&type=script&lang=js"
export * from "./EventRemoveTeamDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f00bd8",
  null
  
)

export default component.exports